// extracted by mini-css-extract-plugin
module.exports = {"row":"FormListItem_row__usNoB","name":"FormListItem_name__1H_rB","status":"FormListItem_status__2Iu_a","badge":"FormListItem_badge__3wydc"};